import { redirect } from '@modern-js/runtime/router';
import { getSystem } from '@/utils';

export const loader = async () => {
  const systemInfo = getSystem();
  const rootPath = '/notebook';
  return redirect(rootPath);
};
